import moment from "moment";

import Utils from "../../../../helpers/utils";
import SettingsHelper from "../../more/SettingsHelper";

export default function CardUtils(controller, data, setShowCard = () => {}) {
  const getCardStorageId = () => {
    return `card:${data.type}:${data.card_id}`;
  };

  this.closeCard = () => {
    this.snoozeCard("Dismiss");
  };

  this.snoozeCard = (option) => {
    let payload = {};
    if (option === "Dismiss") {
      setShowCard(false);
      payload = { hide: true };
    } else if (option === "Move to feed") {
      setShowCard(true);
      payload = {};
    } else {
      setShowCard(false);

      payload = {
        snooze_until: this.getSnoozedTime(option),
      };
    }

    SettingsHelper.storeData(controller, getCardStorageId(), payload);
  };

  this.restoreCard = (storageData) => {
    const cardData =
      typeof storageData === "string"
        ? JSON.parse(storageData)
        : storageData || {};

    let isVisible = true;
    if (cardData?.hide) isVisible = false;
    if (isVisible && cardData.snooze_until) {
      isVisible = cardData.snooze_until < moment().unix();
    }

    setShowCard(isVisible);
  };

  this.getSnoozedTime = (snooze) => {
    let snoozeEndDate = Utils.nowUserTz(controller);
    const dayOfTheWeek = snoozeEndDate.weekday();

    if (snooze == "Later today") {
      snoozeEndDate = snoozeEndDate.add(4, "hours");
    }

    if (snooze == "Tomorrow") {
      snoozeEndDate = snoozeEndDate.add(1, "days").hour(8).minute(0);
    }

    if (snooze == "Later this week") {
      // Monday, Tuesday, Saturday or Sunday
      if ([1, 2, 6, 7].includes(dayOfTheWeek)) {
        snoozeEndDate = snoozeEndDate.add(72, "hours");
        // Friday
      } else if (dayOfTheWeek == 5) {
        snoozeEndDate = snoozeEndDate.add(1, "days").hour(14).minute(0);
      } else {
        snoozeEndDate = snoozeEndDate
          .startOf("isoWeek")
          .add(5, "days")
          .hour(8)
          .minute(0);
      }
    }

    if (snooze == "Next week") {
      if (dayOfTheWeek == 1) {
        snoozeEndDate = snoozeEndDate.add(7, "days").hour(8).minute(0);
      } else {
        snoozeEndDate = snoozeEndDate
          .add(1, "week")
          .startOf("isoWeek")
          .add(1, "days")
          .hour(8)
          .minute(0);
      }
    }

    return snoozeEndDate.unix();
  };
}
